// function range(start, stop, count) {
//     const step = (stop - start) / count;
//     return Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + (i * step));
// }

function range(start, stop, count) {
    const step = (stop - start) / (count - 1);
    const result = [];
    for (let i = 0; i < count; i++) {
        result.push(start + i * step);
    }
    return result;
}

function mergeMaps(map1, map2) {
    for (let key in map2) {
        if (map2.hasOwnProperty(key)) {
            if (map1[key] && typeof map1[key] === 'object' && !Array.isArray(map1[key]) &&
                typeof map2[key] === 'object' && !Array.isArray(map2[key])) {
                // If both values are objects, merge them recursively
                mergeMaps(map1[key], map2[key]);
            } else if (!(key in map1)) {
                // If the key is not present in map1, add it from map2
                map1[key] = map2[key];
            }
        }
    }
    return map1;
}

export { range,mergeMaps }